module.exports = __webpack_public_path__ + "static/media/personal-site.a85e9e4b.jpg";